import React from "react";
import PropTypes from "prop-types";

function CheckBox(props) {
    function handleChange(event) {
        let value = event.target.checked;
        props.onChange(event, "check", props.id, value, true);
    }  

    return (
        <div className="row mb-2">
            <div className="col-sm-12" >
                <div className="form-check form-switch">
                    <input
                        id={props.id}
                        type="checkbox"
                        className="form-check-input"
                        checked={props.value}
                        onChange={event => handleChange(event)}
                    />
                    <label className="form-check-label" htmlFor={props.id}>
                        {props.label}
                    </label>
                </div>
            </div>
        </div>
    );
}

CheckBox.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.bool
};

CheckBox.defaultProps = {
    label: false,
};

export default CheckBox;
